import type { ParticipantGender } from '@/state/stores/registrationStore';

/** UI «Mr.» / чемпионат: в сторе и API бывает `male` или устаревшее `mr`. */
export function isSalutationMrSelection(
  g: ParticipantGender | undefined | null,
): boolean {
  return g === 'mr' || g === 'male';
}

/** UI «Ms.» / чемпионат: `female` или устаревшее `ms`. */
export function isSalutationMsSelection(
  g: ParticipantGender | undefined | null,
): boolean {
  return g === 'ms' || g === 'female';
}
